<div fxLayout="column" fxLayoutAlign="center center" class="neutral-theme">
  <div class="title-container" fxLayout="column" fxLayoutAlign="center center">
    @if (!inPreviewMode) {
      <h1>
        {{ survey?.publicTeamName ? survey.publicTeamName : survey?.teamName }}
      </h1>
    }
    <h2>{{ survey?.displayTitle }}</h2>
    @if (survey?.form.isAnonymousSurvey && !survey?.hasCompleted) {
      <div class="banner" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon>info</mat-icon>
        <span>Your responses are anonymous.</span>
      </div>
    }
  </div>
  @if (isLoadingOrSaving) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    </div>
  }
  @if (!isLoadingOrSaving && !inPreviewMode) {
    <div class="survey">
      <router-outlet></router-outlet>
    </div>
  }

  @if (!isLoadingOrSaving && inPreviewMode) {
    <div class="survey">
      @if (surveyHasIntroduction) {
        <survey-introduction
          [inPreviewMode]="inPreviewMode"
          (previewSurveyStart)="startSurvey()"
        >
        </survey-introduction>
      }
      @if (isSurveyStarted) {
        <survey-respond
          [inPreviewMode]="inPreviewMode"
          (previewSurveySave)="saveSurvey()"
        >
        </survey-respond>
      }
      @if (surveySaved) {
        <survey-confirmation [inPreviewMode]="inPreviewMode">
        </survey-confirmation>
      }
    </div>
  }
</div>
